import anime from 'animejs';
import Medusa from '@adoratorio/medusa';
import engine from '@/scripts/engine';

function clamp(v, min = 0, max = 1) {
  return Math.min(max, Math.max(min, v));
}

function invlerp(a, b, v) {
  return clamp((v - a) / (b - a));
}

function animationTitle(el) {
  return anime({
    targets: el,
    translateY: {
      value: [0, '25vh'],
      easing: 'linear',
    },
    opacity: [1, 0],
    easing: 'easeOutQuad',
    delay: 50,
    duration: 30,
    autoplay: false,
  });
}

function animationSubtitle(el) {
  return anime({
    targets: el,
    translateY: {
      value: [0, '20vh'],
      easing: 'linear',
    },
    opacity: [1, 0],
    easing: 'easeOutQuad',
    delay: 50,
    duration: 20,
    autoplay: false,
  });
}

export default {
  id: 'parallaxTitle',
  nodes: '.hero',
  container: document.getElementById('app'),
  threshold: Medusa.THRESHOLD.BEARLY,
  offsets: '-10px 0px 0px 0px',
  emitGlobal: false,
  callback: ({ isIntersecting, target }) => {
    if (isIntersecting) {
      const { height } = target.getBoundingClientRect();

      // eslint-disable-next-line max-len
      const scroll = offsetTop => invlerp(-window.innerHeight, height, -offsetTop);

      const parallaxSubtitle = animationSubtitle(target.children[0]);
      const parallaxTitle = animationTitle(target.children[1]);

      engine.add(() => {
        const scrollPercentage = scroll(target.getBoundingClientRect().top) * 100;
        parallaxTitle.seek(scrollPercentage);
        parallaxSubtitle.seek(scrollPercentage);
      }, target);
    } else {
      engine.remove(target);
    }
  },
  mode: Medusa.MODE.DEFAULT,
};
